import styled, { css } from 'styled-components';

export const BreadcrumbContainer = styled.li(
  ({ theme }) => css`
    padding-right: ${theme.sz.s2};
    display: inline;

    &::after {
      content: '>';
      padding-left: ${theme.sz.s2};
    }

    &:last-child {
      padding-right: 0;
      pointer-events: none;

      &::after {
        content: none;
      }
    }
  `,
);

export const Breadcrumb = styled.a(
  () => css`
    color: inherit;
    text-decoration: none;
  `,
);
